export default "__VITE_ASSET__e9ca9975__"